"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchers = void 0;
var Actions = require("@caddigital/sok-reducers/lib/actions/vektorio/");
var mapDispatchers = function (dispatch) { return ({
    selectItem: function (folder, value) {
        return dispatch(Actions.folderTree.selectFile(folder, value));
    },
    changeExpand: function (expand, folder) {
        return dispatch(Actions.folderTree.copyChangeExpand(expand, folder));
    },
    getContent: function (parent) {
        return dispatch(Actions.folderTree.fetchTree(parent, ['FOLDER'], 'MINIMAL', false));
    }
}); };
exports.mapDispatchers = mapDispatchers;
